<template>
  <div class="confirm-modal">
    <div class="common-table">
      <div class="common-table__row common-table__header">
        <div class="common-table__header-cell" style="flex: 0 0 360px">
          {{ tableHeader[0] }}
        </div>
        <div class="common-table__header-cell" style="flex: 0 0 50px">
          {{ tableHeader[1] }}
        </div>
        <div class="common-table__header-cell" style="flex: 0 0 95px">
          {{ tableHeader[2] }}
        </div>
      </div>
      <div
        v-for="(item, index) in tableRow"
        :key="index"
        class="common-table__row"
      >
        <div class="common-table__cell" style="flex: 0 0 360px">
          {{ item }}
        </div>
        <div class="common-table__cell" style="flex: 0 0 50px">
          <base-radio-check-box
            v-model="checkboxModel[index]"
            value="true"
          />
        </div>
        <div class="common-table__cell" style="flex: 0 0 95px">
          <base-radio-check-box
            v-model="checkboxModel[index]"
            value="false"
          />
        </div>
      </div>
    </div>

    <div v-if="subtitle" class="confirm-modal__subtitle">
      {{ subtitle }}
    </div>

    <div class="confirm-modal__footer">
      <button class="confirm-modal__button confirm-modal__button_cancel"
              @click.prevent="close(false)">{{ noText }}</button>
      <button class="confirm-modal__button confirm-modal__button_delete"
              @click.prevent="close(true)">{{ yesText }}</button>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'

export default {
  name: 'BaseConfirmReplaceModal',
  mixins: [BaseModalMixins],
  props: {
    tableHeader: {
      type: Array,
      required: true
    },
    tableRow: {
      type: Array,
      required: true
    },
    yesText: {
      type: String,
      default: 'Yes'
    },
    noText: {
      type: String,
      default: 'No'
    },
    subtitle: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      checkboxModel: []
    }
  },
  created () {
    this.checkboxModel.length = this.tableRow.length
    this.checkboxModel.fill('true')
  },
  methods: {
    close (status = false) {
      this.$emit('confirm', status && this.checkboxModel)
    }
  }
}
</script>

<style scoped lang="scss">
  .confirm-modal {
    padding: 40px;
    box-shadow: 0 16px 32px 0 rgba(1, 22, 39, 0.5);

    .common-table {
      border: 1px solid $rfx-light-steel;

      &__header-cell {
        color: $rfx-dark-march;
        background-color: rgba(1, 22, 39, .1);
        border-right: 1px solid $rfx-light-steel;

        &:last-child {
          border-bottom: none;
        }
      }

      &__cell {
        color: $rfx-dark-march;
        border-right: 1px solid $rfx-light-steel;
        display: flex;
        align-items: center;
        justify-content: center;

        &:last-child {
          border-right: none;
        }
      }

      &__row {
        border-bottom: 1px solid $rfx-light-steel;

        &:last-child {
          border-bottom: none;
        }
      }
    }

    &__subtitle {
      margin-top: 16px;
      font-family: Roboto;
      text-align: center;
      font-size: 14px;
      color: $rfx-red;
    }

    &__footer {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    &__button {
      min-width: 100px;
      padding: 0 25px;
      height: 40px;
      font-size: 10px;
      font-weight: 900;
      cursor: pointer;
      text-transform: uppercase;
      border-radius: 8px;
      outline: none;
      border: none;

      &_cancel {
        color: $rfx-dark-march;
        background-color: transparent;
        margin-right: 15px;
      }

      //&_add {
      //  color: #fff;
      //  background-color: $rfx-dark-march;
      //  margin-left: 15px;
      //}

      &_delete {
        color: #fff;
        background-color: $rfx-red;
        margin: 0 15px;
      }
    }
  }
</style>
